<div class="zero-section-wrap">
    <div class="section" [id]="entity().id" [attr.data-raw-id]="entity().id">
        @for (column of entity().children; track $index; let i = $index) {
            <div class="column-container">
                <web-zero-column
                    [index]="i"
                    [entity]="column"
                    [parentEntity]="entity()"
                    [parentEntityIndex]="index()"
                    [blockId]="parentEntityId()"
                    [disableColumnCopy]="columnsCountReachedMax()"
                    [isLastColumn]="isLastSection() && columnCount() === 1"
                />
            </div>
        }
    </div>
</div>
